var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { SettingsPanelComponent } from '../settings-panel.component';
import { FormControl } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
var GeneralSettingsComponent = /** @class */ (function (_super) {
    __extends(GeneralSettingsComponent, _super);
    function GeneralSettingsComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.customPages = [];
        _this.customPageSearch = new FormControl();
        return _this;
    }
    GeneralSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setHomepageValue();
        this.pages.getAll().subscribe(function (response) {
            _this.customPages = response.data;
            var page = _this.customPages.find(function (customPage) { return customPage.id === _this.state.initial.client['homepage.value']; });
            _this.customPageSearch.setValue(page ? page.slug : '');
            _this.filteredCustomPages = _this.customPageSearch.valueChanges.pipe(startWith(''), map(function (val) { return _this.filterPages(val); }));
        });
    };
    /**
     * Save current settings to the server.
     */
    GeneralSettingsComponent.prototype.saveSettings = function () {
        var _this = this;
        var settings = this.state.getModified();
        if (this.state.client['homepage.type'] === 'page' && this.customPageSearch.value) {
            var page = this.customPages.find(function (customPage) { return customPage.slug === _this.customPageSearch.value; });
            if (page)
                settings.client['homepage.value'] = page.id;
        }
        _super.prototype.saveSettings.call(this, settings);
    };
    GeneralSettingsComponent.prototype.getHomepageComponents = function () {
        return this.customHomepage.getComponents();
    };
    /**
     * Filter custom pages by specified query.
     */
    GeneralSettingsComponent.prototype.filterPages = function (query) {
        return this.customPages.filter(function (page) { return page.slug.toLowerCase().indexOf(query.toLowerCase()) === 0; });
    };
    GeneralSettingsComponent.prototype.getDisplayName = function (path) {
        return path.replace(/-/g, ' ').replace(/\b\w/g, function (l) { return l.toUpperCase(); });
    };
    GeneralSettingsComponent.prototype.setHomepageValue = function () {
        if (this.state.client['homepage.type'] === 'component') {
            var current = this.state.client['homepage.value'];
            if (!current || typeof current !== 'string') {
                this.state.client['homepage.value'] = this.customHomepage.getComponents()[0].path;
            }
        }
        else {
            this.state.client['homepage.value'] = null;
        }
    };
    return GeneralSettingsComponent;
}(SettingsPanelComponent));
export { GeneralSettingsComponent };
